import { css } from 'styled-components';
import { grid, gridUnit } from '../../theme/utils/grid/grid';
import { SpacingName, getSpacing, getTypography, TypographyName } from '../../theme';
import { FormActionsAlign } from './constants';
export const wrapper = _ref => {
  let {
    theme,
    $compact
  } = _ref;
  return css(["", " ", " position:relative;"], grid(theme), getSpacing.margin(theme, [$compact ? SpacingName.NEGATIVE_SMALLEST : SpacingName.NEGATIVE_SMALL, SpacingName.NEGATIVE_SMALLEST, 0]));
};
export const title = _ref2 => {
  let {
    theme,
    $compact
  } = _ref2;
  return css(["", " ", " flex-basis:100%;"], getTypography(theme, TypographyName.H3), getSpacing.padding(theme, [$compact ? SpacingName.SMALLEST : SpacingName.SMALL, SpacingName.SMALLEST, 0]));
};
export const item = _ref3 => {
  let {
    theme,
    $size,
    $compact
  } = _ref3;
  return css(["", " ", ";box-sizing:border-box;"], gridUnit(theme, {
    size: $size || 1
  }), getSpacing.padding(theme, $compact ? SpacingName.SMALLEST : [SpacingName.SMALL, SpacingName.SMALLEST, 0]));
};
export const group = _ref4 => {
  let {
    theme
  } = _ref4;
  return css(["", " flex-basis:100%;"], grid(theme));
};
export const groupLabel = _ref5 => {
  let {
    theme
  } = _ref5;
  return css(["flex-basis:100%;", " ", ""], getSpacing.padding(theme, [SpacingName.SMALL, SpacingName.SMALLEST, 0]), getSpacing.marginBottom(theme, SpacingName.NEGATIVE_SMALL));
};
export const groupHelp = _ref6 => {
  let {
    theme
  } = _ref6;
  return css(["flex-basis:100%;", ""], getSpacing.padding(theme, [0, SpacingName.SMALLEST]));
};
export const actions = _ref7 => {
  let {
    theme,
    $align,
    $padding
  } = _ref7;
  return css(["display:flex;justify-content:flex-start;border-top:2px solid ", ";", " ", " ", " ", ""], theme.palettes.neutrals.light, getSpacing.paddingTop(theme, $padding), getSpacing.marginTop(theme, SpacingName.SMALL), $align === FormActionsAlign.CENTER && `
    justify-content: center;
  `, $align === FormActionsAlign.RIGHT && `
    justify-content: flex-end;
  `);
};
//# sourceMappingURL=Form.style.js.map